module.exports = __webpack_public_path__ + "img/mt_immersive.727a73c1.jpg";